import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ICompanyFile } from '@leedpulse-monorepo/interfaces';

async function downloadCompanyFile(
  companyId: string,
  file: ICompanyFile,
  auth: Authentication | null
): Promise<{ url: string; filename: string }> {
  try {
    if (!auth) throw new DownloadCompanyFileFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const blob = await HttpClient.getBlob(
      `/backoffice/companies/${companyId}/files/${file.id}/download`,
      auth.token
    );

    return { url: URL.createObjectURL(blob), filename: file.name };
  } catch (e) {
    if (e instanceof DownloadCompanyFileFailure) throw e;
    const errMessage = e instanceof Error ? e.message : 'Une erreur inattendue s’est produite.';
    throw new DownloadCompanyFileFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed'
    );
  }
}

export class DownloadCompanyFileFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default downloadCompanyFile;
